<template>
  <div class="service-type-groups">

    <v-list class="v-list--bordered">
      <v-list-tile
        avatar
        ripple
      >
        <div class="v-list__tile__avatar" v-if="logo">
          <avatar-logo
            :src="logo"
            :alt="provider.name"
          />
        </div>
        <v-list-tile-avatar v-else>
          <v-icon class="grey lighten-1 white--text">domain</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ provider.name }}</v-list-tile-title>
          <v-list-tile-sub-title v-if="label">{{ label }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-list subheader class="mb-0 pb-0">
      <v-subheader>What type of service is this?</v-subheader>
    </v-list>
    <div class="service-type__selection">
      <v-list class="lvl1 pb-0"
        v-if="currentMenu == 'st-root'"
      >
        <v-divider />
        <template v-for="st in featuredServiceTypes" v-if="!!st.parent_id">
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-checkbox :value="st" v-model="selectedItems"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ st.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
        </template>
        <v-list-tile @click.prevent="updateMenu('stg-root')">
          <v-list-tile-content>
            <v-list-tile-title>Other Services</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-list
        :class="stgKlasses"
        class="pb-0"
        v-if="currentMenu == 'stg-root'">
        <template v-if="featuredServiceTypes.length">
          <v-list-tile @click.prevent.stop="updateMenu('st-root')">
            <v-list-tile-content>
              <v-list-tile-title>
                <v-icon class="mr-2">chevron_left</v-icon>Back
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
        </template>
        <template v-for="stg in allServiceTypes">
          <v-list-tile :key="stg.id" @click.prevent.stop="updateMenu(`stg-${stg.id}`)">
            <v-list-tile-content>
              <v-list-tile-title>{{ stg.name }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>chevron_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
        </template>
      </v-list>

      <v-list
        :class="stgKlasses"
        class="pb-0"
        v-for="stg in allServiceTypes"
        :key="stg.id"
        v-if="currentMenu == `stg-${stg.id}`"
      >
        <template>
          <v-list-tile @click.prevent.stop="updateMenu('stg-root')">
            <v-list-tile-content>
              <v-list-tile-title>
                <v-icon class="mr-2">chevron_left</v-icon>Back
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
        </template>
        <template v-for="st in stg.service_types" v-if="!inFeaturedServiceTypes(st)">
          <v-list-tile @click.prevent.stop="updateMenu(`stg-${stg.id}`)">
            <v-list-tile-action>
              <v-checkbox
              :value="st"
              v-model="selectedItems"
              ></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ st.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { logoFor } from '@/helpers/providers'
  import AvatarLogo from '@/components/common/AvatarLogo'

  export default {
    data: function () {
      return {
        currentMenu: 'st-root'
      }
    },
    computed: {
      ...mapState('serviceTypes', ['allServiceTypes']),
      selectedItems: {
        get () {
          return this.selectedServiceTypes
        },
        set (serviceTypes) {
          this.$emit('update:selectedServiceTypes', serviceTypes)
        }
      },
      label () {
        return this.selectedServiceTypes.map((st) => {
          return st.name
        }).join(', ')
      },
      logo () {
        return logoFor(this.provider, {size: 'small'})
      },
      stgKlasses () {
        return this.featuredServiceTypes.length
          ? ['lvl2']
          : ['lvl1']
      },
      stKlasses () {
        return this.featuredServiceTypes.length
          ? ['lvl3']
          : ['lvl2']
      }

    },
    created () {
      if (!this.allServiceTypes.length) {
        this.getAllServiceTypes()
      }
      this.setMenu()
    },
    methods: {
      setMenu () {
        this.currentMenu = this.featuredServiceTypes.length ? 'st-root' : 'stg-root'
      },
      getAllServiceTypes () {
        this.$store.dispatch('serviceTypes/getAllServiceTypes')
      },
      inFeaturedServiceTypes (serviceType) {
        return !!(this.featuredServiceTypes.length && this.featuredServiceTypes.filter((st) => {
          return !!st.parent_id && serviceType.id == st.id
        }).length)
      },
      updateMenu (menu) {
        this.currentMenu = menu
      }
    },
    props: ['provider', 'selectedServiceTypes', 'featuredServiceTypes'],
    components: {
      AvatarLogo
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/common/ServiceTypeGroups.vue